goog.provide('el8.apphome.reqAct.messages');

goog.require('el8.apphome.reqAct.QueueTab');
goog.require('el8.apphome.reqAct.reqActPatients');

goog.require('el8.util.workspace');

function groupMapper(group){
    return {
        name: typeof group.getName === "function" ? group.getName() : group.name || group._name,
        id: typeof group.getId === "function" ? group.getId() : group.id || group._id
    };
}

function reduceToSetlike(accum, curr) { 
    accum[curr.id] = true;
    return accum;
}

el8.apphome.reqAct.messages = (function() {

    var name = 'messages';

    var that = new el8.apphome.reqAct.QueueTab({
        name: name,
        title: 'Office Messages',
        emptyMsg: 'No messages requiring action',
        addlFeedRenderFn: function() {
            this._populateFilterList()
        }
    });

    // To track the state of the filtering dropdown for that._populateFilterList()
    that.selectedFilter = undefined;
    that.lastQueueType = undefined;

    var super_init = that.init;
    that.init = function(spec) {
        super_init.call(that, spec);
        that.updateQueueType(spec.queueType);
        that._queueContainer.on('change', '#req-act-messages-filter',  function(e) {
            that.selectedFilter = $(this).val();
            that._feed.updateIndexUrl($(this).val());
            that._feed.refresh({
              newestFirst: that._sortNewestFirst
            });
        });
    };

    var super_updateQueueType = that.updateQueueType;
    that.updateQueueType = function(queueType, isShowing) {
        super_updateQueueType.apply(that, arguments); // sets that.queueType
        that.selectedFilter = undefined; // filters reset on queue type change
        /* 
        * visually we want the filter list to have the right top pick which this will do,
        * and it will run again on render (isShowing and the network response is processed)
        * which could provide data that changes dropdown options when in a workspace
        */
        that._populateFilterList();
    };

    /**
     *  Helper function to get groups the filter list may care about in workspaces
     */
    that.getAllGroupRecipientsOnAllMessages = function(){
        var ret = [];
        // The "to" fields are deeply burried
        el8.apphome.reqAct.reqActPatients.all().forEach(
            function(currPatient){ 
                currPatient.getMessageThreadMaps().forEach(
                    function (thread) {
                        // Members can be individuals too, but they don't appear in the dropdown
                        ret = ret.concat(thread.members.filter( function (member){ return member.group } ))
                    }
                )
            }
        )
        return ret;       
    }


    /**
     *  Helper function to populate the special filter list that messages has
     */
    that._populateFilterList = function() {
        // Outside of a workspace rerender only on queue type changes, and note that this covers filter
        // changes and refreshes outside of workspace too because those don't alter queue type
        var isRerenderPointless = that.lastQueueType === that._queueType && !el8.util.workspace.isInEffect();

        // In a workspace, setting the filter to a non-default meant dropdown rerenders lost the setting
        var isRerenderDangerous = that.selectedFilter && that.selectedFilter !== that._queueType;

        if (isRerenderPointless || isRerenderDangerous){
            return;
        }

        var addresseeName, userId, groups, unfilteredGroups = null;

        if (!isNaN(that._queueType*1)) { // have user id
            var user = el8.data.practiceUsers.getById(that._queueType*1);
            userId = user.getId();
            addresseeName = (userId === el8.data.currUser.getId()) ? 'Self' : user.getFullName();
            unfilteredGroups = el8.util.workspace.isInEffect() && el8.data.staffGroups.getGroupsForUser(userId);
            groups = el8.data.staffGroups.getGroupsForUserInWorkspace(userId);
        } else {
            addresseeName = that._queueType;
            unfilteredGroups = el8.util.workspace.isInEffect() && el8.data.staffGroups.getGroupsForUserGroup(that._queueType);
            groups = el8.data.staffGroups.getGroupsForUserGroupInWorkspace(that._queueType);
        }

        groups = groups.map(groupMapper)

        // Look to see if we're in a workspace that is filtering too many groups e.g. messages could
        //  be coming in from outside the workspace and those destination groups should be selectable
        if (el8.util.workspace.isInEffect()){
            var unfilteredGroupIds = unfilteredGroups.map(groupMapper).reduce(reduceToSetlike, {})
            var groupIds = groups.reduce(reduceToSetlike, {})

            that.getAllGroupRecipientsOnAllMessages().forEach( function (member){
                var groupId = member.group.id;
                // We have a "To" field item, but it isn't relevent when
                //  1) we already have this group
                //  2) it would not have appeared outside workspaces
                if ( !groupIds[groupId] && unfilteredGroupIds[groupId] ){
                    groups.push(groupMapper(member.group))
                    groupIds[groupId] = true;
                }
            });
        }

        // Track that we just handled this case and may not need to rebuild and reset the dropdown
        that.lastQueueType = that._queueType;

        $('#req-act-messages-filter', that._queueContainer).html(
            el8.template.render.reqAct.messagesFilterList({
                queueType: that._queueType,
                addresseeName: addresseeName,
                userId: userId,
                groups: groups
            })
        );
    };

    return that;

})();
